import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoints';

/**
 * @param {string | undefined} processId
 * @param {{ enabled?: boolean, placeholderProcess?: object | null }} [options]
 */
export function useProcessById(processId, options = {}) {
  const { enabled = true, placeholderProcess = null } = options;
  const id = String(processId ?? '').trim();

  return useQuery({
    queryKey: ['process', id],
    enabled: enabled && Boolean(id),
    queryFn: async () => {
      const response = await axiosInstance.get(API_ENDPOINTS.getProcessById(id));
      return response.data?.data ?? response.data?.process ?? response.data ?? null;
    },
    placeholderData: placeholderProcess ?? undefined,
  });
}
